import React , { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { forwardRef } from 'react';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { Redirect } from "react-router";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import {DateInput, DateInputSimple, DateTimeInput, DateTimeInputSimple} from 'react-hichestan-datetimepicker';
import { StylesProvider, ThemeProvider } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";
import { jssPreset } from "@material-ui/core/styles";
import RTL from "layouts/Dashboard";
import { Button } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import MaterialTable2 from "./users (copy)"
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });


const theme4 = createMuiTheme({
  typography: { useNextVariants: true },
  direction: "ltr"
});
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function changeState(){
  console.log('hello')
  // this.secondaryFun()
}
export default class users extends React.Component {
  constructor(props) {
      super(props);
      
       this.state = {
	       action:false,   
        columns: [
          { title: 'برچسب زن' , field: 'LabelTask' },
          // { title: 'نام', field: 'name' },
          { title: 'تحصیلات', field: 'Education' },
          // { title: 'سال تولد', field: 'B' },
          { title: 'شماره تماس', field: 'PhoneNumber' },
          { title: 'شغل', field: 'Job' },
          { title: 'ایمیل', field: 'Email' },
          { title: 'نام خانوادگی', field: 'FamilyName' },
          { title: 'نام', field: 'Name' },
          // {
          //   title: 'Birth Place',
          //   field: 'birthCity',
          //   // lookup: { 34: 'İstanbul', 63: 'Şanlıurfa' },
          // },
        ],
        data: [],
        labeling_task: [],
      };
         
          };
  //  handleChange = (event) => {
  //   setState({ ...state, [event.target.name]: event.target.checked });
  //   var a = this.state.labeling_task
  //   this.setState({

      

  //   })
  // };
 dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
componentDidMount(){
  var data_copy=[];
  var label_copy=[];
    //  fetch("http://conalysis.ihcs.ac.ir:8080/get_users", {
      fetch("http://conalysis.ihcs.ac.ir:8080/get_users", {

    method: "GET",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
})
    .then((response) => response.json())
    .then((responseJson) => {
        console.log(responseJson);
        console.log(responseJson[0].email);
        // console.log(responseJs]on[1][0]);
        // console.log(responseJson[1][0][0]);
        // if(responseJson.d==="done↵"){
        responseJson.map((option, index) => {



          label_copy.push(option.labeling_task)

          this.setState({
               
            labeling_task:label_copy
      
          })





          var newData={ Name: option.name,FamilyName: option.familyname,PhoneNumber: option.phonenumber, Education: option.education, Email: option.email, Job: option.job}
          // const data = [...prevState.data];
          newData.LabelTask=<Switch
          checked={this.state.labeling_task[index]}
          // checked={option.labeling_task}
          onChange={()=>this.handleChange1(option.email,index,option.labeling_task)}
          // name="checkedA"
          name="checkedA"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
        />
          data_copy.push(newData)
        
        })
     
        this.setState({
               
          data:data_copy.sort(this.dynamicSort("Email"))
    
        })
     
        
    })
    .catch((error) => {
        console.log(error);
    });
  

}
check22() {
        if (this.state.action) {
        //   console.log("entered");
          return (
            // <BrowserRouter>
            <Redirect
              to={{
                pathname: "/",
                // state: {
                //   token: this.state.token,
                //   UserName: this.state.UserName,
                // },
              }}
            />
            // </BrowserRouter>
          );
        }
      }
handleChange1(email,index){
// var x = this.state.labeling_task
// if(this.state.labeling_task[index])
console.log(!this.state.labeling_task[index])
var data_copy=[];
var label_copy=[];
    //fetch("http://conalysis.ihcs.ac.ir:8080/change_labeling_state", {
    fetch("http://conalysis.ihcs.ac.ir/change_labeling_state", {

  method: "Post",
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
  },
  body: JSON.stringify({
    label: !this.state.labeling_task[index],
    email: email,
}),
})
  .then((response) => response.json())
  .then((responseJson) => {
      console.log(responseJson);
      // console.log(responseJson[0].email);
      // // console.log(responseJs]on[1][0]);
      // // console.log(responseJson[1][0][0]);
      // // if(responseJson.d==="done↵"){
      responseJson.map((option, index) => {



        label_copy.push(option.labeling_task)

        this.setState({
             
          labeling_task:label_copy
    
        })





        var newData={  Name: option.name,FamilyName: option.familyname,PhoneNumber: option.phonenumber, Education: option.education, Email: option.email, Job: option.job}
        // const data = [...prevState.data];
        newData.LabelTask=<Switch
        checked={this.state.labeling_task[index]}
        // checked={option.labeling_task}
        onChange={()=>this.handleChange1(option.email,index,option.labeling_task)}
        // name="checkedA"
        name="checkedA"
        inputProps={{ 'aria-label': 'secondary checkbox' }}
      />
        data_copy.push(newData)
      
      })
   
      this.setState({
             
        data:data_copy.sort(this.dynamicSort("Email"))
    
  
      })
   
      
  })
  .catch((error) => {
      console.log(error);
  });


}
// handleChange1(email,index,labeling_task){
// var x = this.state.labeling_task
// console.log(x)

// x[index]=0
// console.log(x)
// this.setState({

// labeling_task:x

// })
// x[index]=0
// console.log(x)
// this.setState({

//   labeling_task:x

// })

// }
  render() {
     
      return (
	      <div>
                <GridContainer>
	      <Button
                                        className="button"
                                        style={{marginTop:"-5%",marginRight:"95%",borderRadius:"20px",fontFamily:"Btitr", fontSize:16,width:"2%",height:"3%",backgroundColor: "rgb(0,191,214)"}}
                                        onClick={() =>
                                            {
                                                this.setState({
                                                    action:true
                                                })
                                            }

                                        }
                                    // onClick={this.handleSubmit}
                                    >
                                        خروج
                                    </Button>
                                   {
                                       this.state.action ? <div>{this.check22()}</div>: null
                                   }
        <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader  color="primary">
                                <h4  style={{fontFamily:'Bnazanin',fontSize:29}}>لیست کاربران</h4>
                                {/* <p className={this.state.classes.cardCategoryWhite}> */}
                                    {/*New employees on 15th September, 2016*/}
                                {/* </p> */}
                            </CardHeader>
                            <CardBody>

                           
        <div style={{position: "relative",
            top: "0",
            height: "100vh",
            direction: "ltr"}} >
             
           
          <MaterialTable
              title=""
              columns={this.state.columns}
              data={this.state.data}
              icons={tableIcons}
              options={{
                  cellStyle:{
                      fontFamily: "Bnazanin",
                      fontSize: 22,
                      textAlign: "center",
                  },
                  rowStyle: {
                      fontFamily: "Bnazanin",
                      fontSize: 22,
                      // backgroundColor:"blue",
                      // textAlign: "center",
                      // display: 'flex',
                      // padding: 21px 0;
                      // justifyContent
                      // width:"100%",
                      // textAlign: "center",
                      textAlign: "right",
                      // align:"center"
                      // justifyContent: 'flex-end'
                  },
                  headerStyle: {
                      fontFamily: "Btitr",
                      fontSize: 18,
                      textAlign: "center",
                  }
              }}
              editable={{
                // onRowAdd: (newData) =>
                //   new Promise((resolve) => {
                //     setTimeout(() => {
                //       resolve();
                //       // setState((prevState) => {
                //       //   const data = [...prevState.data];
                //       //   newData.name1=<Switch
                //       //   checked={state.checkedA}
                //       //   // onChange={handleChange}
                //       //   name="checkedA"
                //       //   inputProps={{ 'aria-label': 'secondary checkbox' }}
                //       // />
                //       //   data.push(newData);
                //       //   console.log(newData.surname)
                //       //   return { ...prevState, data };
                //       // });
                //     }, 600);
                //   }),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      // if (oldData) {
                        // setState((prevState) => {
                        //   const data = [...prevState.data];
                        //   data[data.indexOf(oldData)] = newData;
                        //   return { ...prevState, data };
                        // });
                        var data_copy=[];
                        var label_copy=[];
                        console.log(newData)
			//                        fetch("http://conalysis.ihcs.ac.ir:8080/update_user", {
			                        fetch("http://conalysis.ihcs.ac.ir:8080/update_user", {

                          method: "Post",
                          headers: {
                              Accept: "application/json",
                              "Content-Type": "application/json",
                          },
                          body: JSON.stringify({
                            // label: !this.state.labeling_task[index],
                            newData: newData,
                            email:oldData.Email
                        }),
                        })
                          .then((response) => response.json())
                          .then((responseJson) => {
                              console.log(responseJson);
                              // console.log(responseJson[0].email);
                              // // console.log(responseJs]on[1][0]);
                              // // console.log(responseJson[1][0][0]);
                              // // if(responseJson.d==="done↵"){
                              responseJson.map((option, index) => {
                        
                        
                        
                                label_copy.push(option.labeling_task)
                        
                                this.setState({
                                     
                                  labeling_task:label_copy
                            
                                })
                        
                        
                        
                        
                        
                                var newData={  Name: option.name,FamilyName: option.familyname,PhoneNumber: option.phonenumber, Education: option.education, Email: option.email, Job: option.job}
                                // const data = [...prevState.data];
                                newData.LabelTask=<Switch
                                checked={this.state.labeling_task[index]}
                                // checked={option.labeling_task}
                                onChange={()=>this.handleChange1(option.email,index,option.labeling_task)}
                                // name="checkedA"
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                              />
                                data_copy.push(newData)
                              
                              })
                           
                              this.setState({
                                     
                                data:data_copy.sort(this.dynamicSort("Email"))
                            
                          
                              })
                           
                              
                          })
                          .catch((error) => {
                              console.log(error);
                          });
  
                      // }
                    }, 900);
                  }),
                  
                onRowDelete: (oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      console.log(oldData.Email)
                      var data_copy=[];
                      var label_copy=[];
			//                      fetch("http://conalysis.ihcs.ac.ir:8080/delete_user", {
			                      fetch("http://conalysis.ihcs.ac.ir:8080/delete_user", {

                        method: "Post",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                          // label: !this.state.labeling_task[index],
                          email: oldData.Email,
                      }),
                      })
                        .then((response) => response.json())
                        .then((responseJson) => {
                            console.log(responseJson);
                            // console.log(responseJson[0].email);
                            // // console.log(responseJs]on[1][0]);
                            // // console.log(responseJson[1][0][0]);
                            // // if(responseJson.d==="done↵"){
                            responseJson.map((option, index) => {
                      
                      
                      
                              label_copy.push(option.labeling_task)
                      
                              this.setState({
                                   
                                labeling_task:label_copy
                          
                              })
                      
                      
                      
                      
                      
                              var newData={  Name: option.name,FamilyName: option.familyname,PhoneNumber: option.phonenumber, Education: option.education, Email: option.email, Job: option.job}
                              // const data = [...prevState.data];
                              newData.LabelTask=<Switch
                              checked={this.state.labeling_task[index]}
                              // checked={option.labeling_task}
                              onChange={()=>this.handleChange1(option.email,index,option.labeling_task)}
                              // name="checkedA"
                              name="checkedA"
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                              data_copy.push(newData)
                            
                            })
                         
                            this.setState({
                                   
                              data:data_copy.sort(this.dynamicSort("Email"))
                          
                        
                            })
                         
                            
                        })
                        .catch((error) => {
                            console.log(error);
                        });






                      // setState((prevState) => {
                      //   const data = [...prevState.data];
                      //   data.splice(data.indexOf(oldData), 1);
                      //   return { ...prevState, data };
                      // });
                    }, 600);
                  }),
              }}
            />
        
        </div>
        </CardBody>
        </Card>
                        
                       
                        </GridItem>
                        
                     </GridContainer>
                   
                 </div>

      )


      }

    
    }

//  function MaterialTableDemo() { 
  
//   // const [state, setState] = React.useState({
//   //   checkedA: true,
//   //   checkedB: true,
//   // });
//   // const [count, setCount] = React.useState({
    
//   //   checkedA: true,
//   // });

  
//   const [state, setState] = React.useState({
//       checkedA: false,
//     // UserList:null,
//     columns: [
//       { title: 'برچسب زن' , field: 'LabelTask' },
//       // { title: 'نام', field: 'name' },
//       { title: 'تحصیلات', field: 'Education' },
//       // { title: 'سال تولد', field: 'B' },
//       { title: 'شماره تماس', field: 'PhoneNumber' },
//       { title: 'شغل', field: 'Job' },
//       { title: 'ایمیل', field: 'Email' },
//       { title: 'نام خانوادگی', field: 'FamilyName' },
//       { title: 'نام', field: 'Name' },
//       // {
//       //   title: 'Birth Place',
//       //   field: 'birthCity',
//       //   // lookup: { 34: 'İstanbul', 63: 'Şanlıurfa' },
//       // },
//     ],
//     data: [],
//     labeling_task: [],
//   });
//   useEffect(() => {
//     fetch("/get_users", {
//       method: "GET",
//       headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//       },
//   })
//       .then((response) => response.json())
//       .then((responseJson) => {
//           console.log(responseJson);
//           console.log(responseJson[0].email);
//           // console.log(responseJs]on[1][0]);
//           // console.log(responseJson[1][0][0]);
//           // if(responseJson.d==="done↵"){
//           responseJson.map((option, index) => {
//             var newLabel={ state_labeling_task:option.labeling_task, Email:option.email}
//               setState((prevState) => {
                
//                 const labeling_task = [...prevState.labeling_task];
//               //   newData.name1=<Switch
//               //   // checked={state.checkedA}
//               //   // onChange={handleChange}
//               //   name="checkedA"
//               //   inputProps={{ 'aria-label': 'secondary checkbox' }}
//               // />
//                labeling_task.push(newLabel);
//                state.labeling_task =labeling_task;
//               console.log(index)
//                 // console.log(labeling_task)
//                 // console.log(labeling_task[0].state_labeling_task)
//                 return { ...prevState, labeling_task };
//               });
//               console.log(state)
//               console.log(state.labeling_task)
//             var newData={ PhoneNumber: option.phonenumber, Education: option.education, Email: option.email, Job: option.job}
//               // const data = [...prevState.data];
//               newData.LabelTask=<Switch
//               checked={state.labeling_task[index].state_labeling_task}
//               // checked={option.labeling_task}
//               onChange={()=>handleChange1(option.email,index,option.labeling_task)}
//               // name="checkedA"
//               name="checkedA"
//               inputProps={{ 'aria-label': 'secondary checkbox' }}
//             />
            
          
//               setState((prevState) => {
//                 const data = [...prevState.data];
//               //   newData.name1=<Switch
//               //   // checked={state.checkedA}
//               //   // onChange={handleChange}
//               //   name="checkedA"
//               //   inputProps={{ 'aria-label': 'secondary checkbox' }}
//               // />
//                 data.push(newData);
//                 // console.log(newData)
//                 return { ...prevState, data };
//               });
              
//             // setState((prevState) => {
//               // const data = prevState.data;
//               // data.push([{ Name: 'Mehmet', FamilyName: 'Baran', Email: 1987}])
//               // console.log(data)
//               // return { ...prevState, data };
//             // });

//           })
//             // React.setState({

//             // })
//           // this.setState({
//           //     response: responseJson,
//           // });
          
//       })
//       .catch((error) => {
//           console.log(error);
//       });


//   }, []);
//   const handleChange1 = (email,index,labeling_task) => {
  
//     var label;
    
//     console.log("oomad")
//       setState((prevState) => {

//   //       var data=[...prevState.data];
//   //   // const data = [...prevState.data];
//   //   data[index].LabelTask=<Switch
//   //   checked={!labeling_task}
//   //   onChange={()=>handleChange1(email,index,labeling_task)}
//   //   // name="checkedA"
//   //   name="checkedA"
//   //   inputProps={{ 'aria-label': 'secondary checkbox' }}
//   // />
//         // const data = [...prevState.data];
//         //   newData.name1=<Switch
//         //   // checked={state.checkedA}
//         //   // onChange={handleChange}
//         //   name="checkedA"
//         //   inputProps={{ 'aria-label': 'secondary checkbox' }}
//         // />
//         // data[index]= { state_labeling_task:!labeling_task[index].state_labeling_task, Email:email}




//         const labeling_task = [...prevState.labeling_task];
//         labeling_task[index]= { state_labeling_task:!labeling_task[index].state_labeling_task, Email:email}
//         console.log(labeling_task)
//         // labeling_task.push(newLabel);
//         state.labeling_task =labeling_task;
//         console.log(state.labeling_task)
        
//         // var checked = labeling_task[index].state_labeling_task;
//         // console.log(checkedA)
//     //     if (checked) {
//     // //   //   newData.name1=<Switch
//     // //   //   // checked={state.checkedA}
//     // //   //   // onChange={handleChange}
//     // //   //   name="checkedA"
//     // //   //   inputProps={{ 'aria-label': 'secondary checkbox' }}
//     //   // />
//     //   label=0;
//     //   checked=false
//     //   console.log(email)
//     // //   c1=false
//     // }
//     //   else{
//     //     label=1;
//     //     checked=true
//     //   }
//     //   fetch("/make_label_task", {
//     //     method: "POST",
//     //     headers: {
//     //         Accept: "application/json",
//     //         "Content-Type": "application/json",
//     //     },
//     //     body: JSON.stringify({
//     //         email: email,
//     //         label: label,
//     //     }),
//     // })
//     //     .then((response) => response.json())
//     //     .then((responseJson) => {
//     //         console.log(responseJson);
        
      
//     //     })
//     //     .catch((error) => {
//     //         console.log(error);
//     //     });






//     //   console.log(c1)
//     //   console.log(state.checkedA)
//         return  {...prevState, labeling_task};
//       });
//       // ()=>useEffect()
   
//     // setCount({ ...count, [event.target.name]: event.target.checked });
//     // console.log(n)
//     // console.log(event.target.checked)
//   };
//   const tableIcons = {
//     Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
//     Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
//     Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
//     Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
//     DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
//     Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
//     Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
//     Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
//     FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
//     LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
//     NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
//     PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
//     ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
//     Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
//     SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
//     ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
//     ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
//   };
//   return (
//     <div style={{position: "relative",
//     top: "0",
//     height: "100vh",
//     direction: "ltr"}} >
     
   
//   <MaterialTable
//       title=""
//       columns={state.columns}
//       data={state.data}
//       icons={tableIcons}
//       editable={{
//         // onRowAdd: (newData) =>
//         //   new Promise((resolve) => {
//         //     setTimeout(() => {
//         //       resolve();
//         //       setState((prevState) => {
//         //         const data = [...prevState.data];
//         //         newData.name1=<Switch
//         //         checked={state.checkedA}
//         //         // onChange={handleChange}
//         //         name="checkedA"
//         //         inputProps={{ 'aria-label': 'secondary checkbox' }}
//         //       />
//         //         data.push(newData);
//         //         console.log(newData.surname)
//         //         return { ...prevState, data };
//         //       });
//         //     }, 600);
//         //   }),
//         onRowUpdate: (newData, oldData) =>
//           new Promise((resolve) => {
//             setTimeout(() => {
//               resolve();
//               if (oldData) {
//                 setState((prevState) => {
//                   const data = [...prevState.data];
//                   data[data.indexOf(oldData)] = newData;
//                   return { ...prevState, data };
//                 });
//               }
//             }, 600);
//           }),
          
//         onRowDelete: (oldData) =>
//           new Promise((resolve) => {
//             setTimeout(() => {
//               resolve();
//               setState((prevState) => {
//                 const data = [...prevState.data];
//                 data.splice(data.indexOf(oldData), 1);
//                 return { ...prevState, data };
//               });
//             }, 600);
//           }),
//       }}
//     />

// </div>

    
  
//   );
// }
